"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintableQuietRoadIcon = PrintableQuietRoadIcon;
var _renderer = require("@react-pdf/renderer");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PrintableQuietRoadIcon(_ref) {
  let {
    color,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_renderer.Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement(_renderer.Path, {
    d: "M12 0c-6.616 0-12 5.383-12 12s5.383 12 12 12 12-5.384 12-12-5.384-12-12-12zM2.79 6.143h3.755c0.517 0.007 0.739 0.332 0.891 0.786l1.188 3.203h-7.38c0.249-1.446 0.786-2.796 1.546-3.989zM8.971 11.694c0.729-0.006 1.326 0.607 1.329 1.368-0.003 0.756-0.598 1.371-1.329 1.368-0.741 0.003-1.336-0.612-1.341-1.368 0.005-0.761 0.6-1.374 1.341-1.368zM12 22.92c-3.995 0-7.492-2.157-9.397-5.366h4.962v1.653c0.007 2.015 2.891 2.037 2.892 0v-1.653h1.537v-5.178c-0.006-1.392-1.113-2.126-1.743-2.208l-1.577-4.065c-0.294-0.779-0.938-1.442-2.155-1.447h-2.595c1.999-2.196 4.878-3.576 8.076-3.576 6.023 0 10.92 4.899 10.92 10.92s-4.898 10.92-10.92 10.92z",
    fill: color
  }));
}